








































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ReturObatVerifikasiItemRow extends Vue {
  @Prop() item!: any;
  @Prop({ default: false }) disabled!: boolean;

  showTolakDialog = false;
  alasanTolak = "";

  terima() {
    this.$emit("verify", {
      itemId: this.item.id,
      status_terima: "diterima",
    });
  }

  tolak() {
    this.$emit("verify", {
      itemId: this.item.id,
      status_terima: "ditolak",
      alasan_tolak: this.alasanTolak,
    });
    this.showTolakDialog = false;
    this.alasanTolak = "";
  }
}
